import React from 'react'
import { VStack } from '@chakra-ui/react'
import { PRM_CombinedResponse } from '../types/unified_models'
import CorrectnessTestModule from './CorrectnessTestModule'
import BenchmarkModule from './BenchmarkModule'
import ParallelAnalysisModule from './ParallelAnalysisModule'
import ProfilerModule from './ProfilerModule'

interface TestResultsProps {
  problemId: string
  response?: PRM_CombinedResponse | null
  sourceCode?: string
}

export default function TestResults({ problemId, response, sourceCode }: TestResultsProps) {
  if (!response) {
    return (
      <VStack spacing={4} align="stretch">
        <CorrectnessTestModule correctness={null} />
        <BenchmarkModule benchmark={null} />
        <ProfilerModule profiler={null} benchmark={null} />
        <ParallelAnalysisModule 
          cilksan={null} 
          cilkscaleBenchmark={null} 
          sourceCode={sourceCode || ''} 
        />
      </VStack>
    )
  }

  return (
    <VStack spacing={4} align="stretch">
      <CorrectnessTestModule correctness={response.correctness || null} />
      <BenchmarkModule benchmark={response.benchmark || null} />
      <ProfilerModule 
        profiler={response.profiler || null} 
        benchmark={response.benchmark || null} 
      />
      <ParallelAnalysisModule 
        cilksan={response.cilksan || null} 
        cilkscaleBenchmark={response.cilkscale_benchmark || null} 
        sourceCode={sourceCode || ''} 
      />
    </VStack>
  )
} 